import * as React from "react";
import * as  ReactDom from "react-dom";

class Overlay extends React.Component<any, any> {
    style = {
        position: "fixed",
        top: "0px",
        left: "0px",
        width: "100%",
        height: "100%",
        opacity: 0,
        zIndex: diy.editor.getNewTopZIndex() - 2
    };

    render() {
        return <div style={this.style}></div>;
    }
}

export default class OverlayApi extends React.Component<any, any> {
    private static container = document.createElement("div");

    static show() {
        document.body.appendChild(this.container);
        ReactDom.render(<Overlay />, this.container);
    }

    static hide() {
        ReactDom.unmountComponentAtNode(this.container);
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/toolbar/notificationNG/components/NotificationCenterOverlay.tsx
 **/